import { Component, Prop, Vue } from 'vue-property-decorator'
import UserImg from './UserImg'
import { UserState } from '@/constant'
@Component({
  components: {
    UserImg
  }
})
export default class UserWrap extends Vue {
  @Prop() userImg !: number
  @Prop() name !: string
  @Prop() active !: UserState

  get userState () {
    return ['online', 'idle', 'do-not-disturb'][this.active]
  }

  render () {
    return (<div class="user-wrap">
      <UserImg class="user-img" userImg={this.userImg}></UserImg>
      <div class="name">{this.name}</div>
      <span class={this.userState + ' active'}></span>
    </div>)
  }
}

// VUE JSX HOT LOADER //
if (module.hot) require("E:\\project\\html\\the-f2e-w7-chatting-room\\node_modules\\vue-jsx-hot-loader\\src\\api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-67f8fa54/UserWrap.tsx" });